import React, { useEffect } from 'react'
import Gap from './Gap'
import { setAppStatusBarDark } from '../utils/flutterStatusBar'
import { useSheetDragDismiss } from '../hooks/useSheetDragDismiss'

export interface TextListBottomSheetItem {
  text: string
  onClick: () => void
  isSelected?: boolean
}

interface TextListBottomSheetProps {
  isOpen: boolean
  onClose: () => void
  items: TextListBottomSheetItem[]
}

const TextListBottomSheet: React.FC<TextListBottomSheetProps> = ({
  isOpen,
  onClose,
  items,
}) => {
  useEffect(() => {
    setAppStatusBarDark(isOpen)
    return () => setAppStatusBarDark(false)
  }, [isOpen])

  const { handleProps, sheetStyle } = useSheetDragDismiss({
    onClose,
    enabled: isOpen,
  })

  if (!isOpen) return null

  const handleItemClick = (item: TextListBottomSheetItem) => {
    item.onClick()
    onClose()
  }

  return (
    <>
      {/* 오버레이 */}
      <div
        className="fixed inset-0 bg-black bg-opacity-40 z-[1070]"
        onClick={onClose}
      />

      {/* 바텀 시트 컨테이너 */}
      <div className="fixed inset-0 z-[1070] flex items-end justify-center pointer-events-none">
        <div
          className={`
            app-container
            bg-ivoryKey
            rounded-t-30px
            flex
            flex-col
            overflow-hidden
            pointer-events-auto
          `}
          style={sheetStyle}
          onClick={(e) => e.stopPropagation()}
        >
          {/* 드래그 핸들 (아래로 끌면 닫힘) */}
          <div
            className="w-full flex justify-center pt-16px pb-24px"
            {...handleProps}
          >
            <div className="w-40px h-4px bg-472410-20% rounded-full" />
          </div>

          <Gap height={10} />

          {/* 리스트 아이템 */}
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <button
                type="button"
                onClick={() => handleItemClick(item)}
                className={`
                  w-full
                  px-24px py-12px
                  font-pretendard font-bold text-16px leading-24px text-brown-80%-main
                  text-left
                  ${item.isSelected ? 'bg-brandPrimary-5%' : ''}
                  hover:bg-brandPrimary-5%
                `}
              >
                {item.text}
              </button>

              {index < items.length - 1 && <Gap height={16} />}
            </React.Fragment>
          ))}

          <Gap height={33} />
        </div>
      </div>
    </>
  )
}

export default TextListBottomSheet
